import { render, staticRenderFns } from "./InfoPanelRoad.vue?vue&type=template&id=4472e4e3&scoped=true"
import script from "./InfoPanelRoad.vue?vue&type=script&lang=ts"
export * from "./InfoPanelRoad.vue?vue&type=script&lang=ts"
import style0 from "./InfoPanelRoad.vue?vue&type=style&index=0&id=4472e4e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4472e4e3",
  null
  
)

export default component.exports